var _path, _g, _path2, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgNoSubmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 114H129.5C147 114 154 107 154 89.5V68.5C154 51 147 44 129.5 44H108.5C91 44 84 51 84 68.5V89.5C84 107 91 114 108.5 114Z",
    fill: "url(#paint0_linear_5982_40586)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5982_40586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    fill: "url(#paint1_linear_5982_40586)",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 43.25,
    y: 43.25,
    width: 103.5,
    height: 103.5
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(8px)",
      clipPath: "url(#bgblur_0_5982_40586_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 16,
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    fill: "url(#paint2_linear_5982_40586)",
    fillOpacity: 0.16,
    stroke: "url(#paint3_linear_5982_40586)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5982_40586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.833 97.5L109.501 94.1667L106.167 97.5M110 95C110 103.284 103.284 110 95 110C86.7157 110 80 103.284 80 95C80 86.7157 86.7157 80 95 80C100.503 80 105.314 82.9636 107.924 87.3818M95 86.6667V95L100 98.3333",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5982_40586",
    x: 0,
    y: 0,
    width: 190,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_5982_40586"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5982_40586_clip_path",
    transform: "translate(-43.25 -43.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5982_40586",
    x: 78.5,
    y: 78.5,
    width: 35.833,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5982_40586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5982_40586",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5982_40586",
    x1: 89,
    y1: 51,
    x2: 142,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC47D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5982_40586",
    x1: 65,
    y1: 67,
    x2: 118,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC47D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5982_40586",
    x1: 65,
    y1: 67,
    x2: 118,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC47D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5982_40586",
    x1: 123,
    y1: 66,
    x2: 66,
    y2: 124.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0285714,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoSubmission);
export default __webpack_public_path__ + "static/media/ImgNoSubmission.8c410b38e9ac9f6725385545c0af210c.svg";
export { ForwardRef as ReactComponent };